import { render, staticRenderFns } from "./item.vue?vue&type=template&id=0ec338b2&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec338b2')) {
      api.createRecord('0ec338b2', component.options)
    } else {
      api.reload('0ec338b2', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=0ec338b2&", function () {
      api.rerender('0ec338b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/webViewCarousel/src/item.vue"
export default component.exports